
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","stroke":"transparent"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.076 17.265v-1.157a2.03 2.03 0 001.509-1.933 2.082 2.082 0 00-1.509-1.945V6.581a.576.576 0 00-1.151-.04.369.369 0 000 .04v5.646a2 2 0 00-1.437 2.46 2.023 2.023 0 001.437 1.406v1.157a.568.568 0 00.573.563.546.546 0 00.574-.516c.004-.01.004-.02.004-.032zm-1.509-3.09a.921.921 0 11.934.913.926.926 0 01-.934-.912zM16.339 6.583v1.2a2 2 0 00-1.437 2.46 2.023 2.023 0 001.437 1.406v5.615a.568.568 0 00.573.563.562.562 0 00.576-.547v-5.632a2 2 0 001.437-2.459 2.027 2.027 0 00-1.437-1.407v-1.2a.569.569 0 00-.573-.563.562.562 0 00-.576.548zm1.509 3.135a.926.926 0 01-.934.913.907.907 0 01-.934-.879.273.273 0 010-.034.926.926 0 01.934-.913.947.947 0 01.934.913zM8.661 17.267v-5.616a2 2 0 001.437-2.459 2.027 2.027 0 00-1.437-1.407v-1.2a.569.569 0 00-.573-.563.562.562 0 00-.576.548v1.218a2 2 0 00-1.437 2.46 2.023 2.023 0 001.437 1.406v5.615a.568.568 0 00.573.563.562.562 0 00.576-.547zM7.152 9.719a.947.947 0 11.985.913h-.051a.925.925 0 01-.934-.914z"}})])
          )
        }
      }
    